/*
 * Сводка владельца (5-В1) — макет есть только телефонный (360). На широком экране
 * карточки раскладываются на всю рабочую область, а не колонкой в 720 px у левого края:
 * так правая половина экрана была пустой, и сводка читалась как недогруженная страница.
 * Потолок 1200 — чтобы на 1920 карточка не растягивалась в полосу, которую читают
 * поворотом головы.
 *
 * ЦВЕТА — ТОЛЬКО ТОКЕНЫ ТЕМЫ. Здесь стояли переменные, которых в теме нет
 * (--warn-bg, --success-text, --danger-text и ещё четыре), и все они молча падали
 * в запасные цвета из чужой палитры: кислотно-зелёный «+20 пунктов», красный «1 неявка»,
 * серые плашки. В тёмной теме эти запасные цвета давали светлые пятна на тёмном фоне.
 */
.screen {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  max-width: 1200px;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/*
 * ЗАГОЛОВОК «СВОДКА» НЕ ПОВТОРЯЕТСЯ НА ЭКРАНЕ. Шапка кабинета уже называет раздел,
 * а на телефоне она же печатает дату и филиал второй строкой — и сводка показывала
 * «Сводка / чт, 24 сентября · Тестовый филиал» два раза подряд, отдав под повтор
 * треть первого экрана. Заголовок остаётся для чтения с экрана (страница без h1 —
 * страница без имени), дата — там, где шапка её не показывает, то есть шире телефона.
 */
.title {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

.subtitle {
  font-size: 14px;
  color: var(--text-secondary);
}

@media (max-width: 767px) {
  .subtitle {
    display: none;
  }
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Полоса офлайна — над карточками, а не под ними: «данные на 14:20» надо прочитать
   ДО того, как поверить числам. */
.offline {
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--status-pending-bg);
  color: var(--status-pending-fg);
  font-size: 14px;
}

.cards {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .cards {
    grid-template-columns: 1fr 1fr;
  }
}

/* Шире 1100 — три колонки: шесть карточек сводки встают ровно двумя рядами. */
@media (min-width: 1100px) {
  .cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

.card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  text-align: left;
}

/* Карточка с разбором — кнопка: она открывает страницу, и это видно до нажатия. */
.cardLink {
  composes: card;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.cardLink:hover {
  border-color: var(--accent);
}

.cardFailed {
  composes: card;
  border-color: var(--status-pending-fg);
}

/* «Записано · предстоит» — ПУНКТИР: этих денег ещё нет, и это видно не читая. */
.cardAhead {
  composes: card;
  border-style: dashed;
}

/* «Получено · состоялось» — ЗАЛИВКА: эти деньги уже есть. */
.cardDone {
  composes: card;
  background: var(--bg-sunken);
  border-color: transparent;
}

.cardTitle {
  font-size: 13px;
  color: var(--text-secondary);
}

.value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  color: var(--text-primary);
}

.valueRow {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.deltaGood {
  font-size: 14px;
  font-weight: 600;
  color: var(--status-in-progress-fg);
}

.deltaBad {
  font-size: 14px;
  font-weight: 600;
  color: var(--status-no-show-fg);
}

.deltaFlat {
  font-size: 14px;
  color: var(--text-secondary);
}

.caption {
  font-size: 13px;
  color: var(--text-secondary);
}

.failure {
  font-size: 13px;
  color: var(--status-pending-fg);
}

.arrow {
  font-size: 13px;
  color: var(--text-secondary);
}

.links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.link:hover {
  border-color: var(--accent);
}

.linkTail {
  font-size: 13px;
  color: var(--text-secondary);
  white-space: nowrap;
}

/* ── Разборы 5-В2 и 5-В3 ─────────────────────────────────────────────────── */

.rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-align: left;
  width: 100%;
}

.row:hover {
  border-color: var(--accent);
}

.rowHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.rowName {
  font-size: 15px;
  font-weight: 600;
}

.rowValue {
  font-size: 15px;
  font-weight: 700;
}

/* Загрузка ниже порога — тревожная: это разговор, а не строка отчёта. */
.rowValueLow {
  composes: rowValue;
  color: var(--status-no-show-fg);
}

.rowCaption {
  font-size: 13px;
  color: var(--text-secondary);
}

.bar {
  height: 6px;
  border-radius: 3px;
  background: var(--border);
  overflow: hidden;
}

.barFill {
  display: block;
  height: 100%;
  background: var(--accent);
}

.barFillLow {
  display: block;
  height: 100%;
  background: var(--danger);
}

/* Строка без перехода: журнал закрыт правом, и делать её кнопкой значит обещать
   нажатие, которое кончится отказом. */
.rowStatic {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--bg-card);
  width: 100%;
}

.footnote {
  font-size: 13px;
  color: var(--text-secondary);
}

.badge {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--bg-sunken);
  color: var(--text-secondary);
  white-space: nowrap;
}

.skeletons {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .skeletons {
    grid-template-columns: 1fr 1fr;
  }
}
